import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, switchMap} from "rxjs";
import {UserApi} from "@app-web-central/web/shared/data-access/stouds-api";
import {loadUsers, loadUsersError, loadUsersSuccess} from "./users.actions";
import {CfUser, ResponseState} from "@app-web-central/web/shared/data-access/models";

@Injectable({ providedIn: 'root' })
export class UsersEffects {

  public loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUsers),
      switchMap(() => this.userApi.list()
        .pipe(
          map((response: ResponseState<CfUser[]>) => loadUsersSuccess({ users: response.payload })),
          catchError((error) => [loadUsersError(error)])
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private userApi: UserApi
  ) { }
}
